import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import {
  ToastController,
  AlertController,
  LoadingController,
} from "@ionic/angular";
import { Subscription } from "rxjs";
import { LoginService } from "src/app/services/login.service";
import { Location } from "@angular/common";
import { AdminService } from "src/app/services/admin.service";
import { SideBarEventService } from "src/app/services/event-Emitter/side-bar.service";
import { Device } from "@capacitor/device";
import { EncryptionService } from "src/app/services/encryption.service";

@Component({
  selector: "app-login-otp",
  templateUrl: "./login-otp.component.html",
  styleUrls: ["./login-otp.component.scss"],
  standalone: false
})
export class LoginOTPComponent implements OnInit {
  isEmailOTPSent: boolean = false;

  // config = {
  //   allowNumbersOnly: false,
  //   length: 4,
  //   isPasswordInput: false,
  //   disableAutoFocus: false,
  //   placeholder: "",
  //   inputStyles: {
  //     width: "40px",
  //     height: "40px",
  //   },
  // };

  // @ViewChild('countdown') counter: CountdownComponent;
  isEmailOTPSend: boolean = false;
  // configTimer = {
  //   leftTime: 30,
  // };
  isOption = "";
  emailValue: any = "";
  emailForm: UntypedFormGroup;
  emailform = {
    Email: "",
  };
  mobileForm: UntypedFormGroup;
  mobileform = {
    code: "+91",
    mobile: "",
  };
  constructor(
    private _formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private location: Location,
    private loginService: LoginService,
    public toastController: ToastController,
    public loadingController: LoadingController,
    
  ) {
    this.emailForm = this._formBuilder.group({
      Email: ["", [Validators.required, Validators.email]],
    });
    this.mobileForm = this._formBuilder.group({
      code: [""],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
    });
  }
  changeOption(event) {
    this.isOption = event.detail.value;
    // this.mobileForm.reset();
    this.mobileForm.controls.mobile.reset();
    this.emailForm.reset();
    // if (event.detail.value=='email') {

    // } else if(event.detail.value=='mobile') {

    // }
  }

  async sendEmailOTP() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Sending OTP...",
    });
    await loading.present();
    const sendOTP = Math.floor(1000 + Math.random() * 9000);
    this.loginService.ValidateLoginUser("").subscribe({
      next: async (res) => {
        this.isEmailOTPSend = true;
        const dialogRef = this.dialog.open(LogInOTPVerificationDialog, {
          width: "250px",
          data: {
            OTPValue: sendOTP,
            value: "email",
          },
        });
        await loading.dismiss();
      },
      error: async (err) => {
        const toast = await this.toastController.create({
          message: "Email ID not registerd. Please enter valid Email ID",
          position: "top",
          duration: 2000,
          color: "danger",
        });
        toast.present();
        await loading.dismiss();
      }
    });
  }
  myBackButton() {
    this.location.back();
  }
  async sendMobileOTP() {


    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Sending OTP...",
    });
    await loading.present();
    const sendOTP = Math.floor(1000 + Math.random() * 9000);
    const object = {
      OtpType: "MobileNo",
      OtpValue: this.mobileform.mobile,
    };
    this.loginService.ValidateLoginUser(object).subscribe({
      next: async (res) => {
        // let resp:any=res;
        this.isEmailOTPSend = true;
        const dialogRef = this.dialog.open(LogInOTPVerificationDialog, {
          width: "250px",
          data: {
            OtpType: "MobileNo",
            OtpValue: this.mobileform.mobile,
            OTP: sendOTP,
            UserId:res
          },
        });
        await loading.dismiss();
      },
      error: async (err) => {
        
        const toast = await this.toastController.create({
          message: "Email ID not registerd. Please enter valid Email ID",
          position: "top",
          duration: 2000,
          color: "danger",
        });
        toast.present();
        await loading.dismiss();
      }
    });
    // const sendOTP = Math.floor(1000 + Math.random() * 9000);
    // const dialogRef = this.dialog.open(LogInOTPVerificationDialog, {
    //   width: "250px",
    //   data: {
    //     OtpType: "MobileNo",
    //     OtpValue: this.mobileform.mobile,
    //     OTP: sendOTP,
    //   },
    // });
    // await loading.dismiss();
  }
  ngOnInit() {}
}

@Component({
    selector: "dialog-overview-example-dialog",
    templateUrl: "login-otp-verification.html",
    standalone: false
})
export class LogInOTPVerificationDialog {
  invalidOTP: boolean = false;
  isvalid: boolean = false;
  sub: Subscription;
  otp: any;
  smsOTP: any;
  isImageSize: any;
  isCounter: boolean = false;
  configTimer = {
    leftTime: 30,
  };
  userDetails: any;
  constructor(
    public dialogRef: MatDialogRef<LogInOTPVerificationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService,
    private toastController: ToastController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public router: Router,
    private adminService: AdminService,
    private sideBarEventService: SideBarEventService,
    private encryptionService: EncryptionService
  ) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  config = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "40px",
      height: "40px",
    },
  };
 
  // reSendOTP() {
  //   // this.createOTP();
  // }

  handleEvent(event) {
    if (event.action == "done") {
      this.isCounter = true;
    }
  }
  onOtpChange(otp) {
    this.otp = otp;
    this.invalidOTP = false;
    if (otp.length === 4) {
      this.isvalid = true;
    } else {
      this.isvalid = false;
    }
  }

  submitOTP() {
    // this.LoginAsOTP(502)
    // this.loginService.loginWithOTP().subscribe(
    //   (res) => {},
    //   (err) => {}
    // );

    // const object = { OtpType: this.data.OtpType, OtpValue: this.data.OtpValue, OTP: this.otp };
    // this.loginService.validateUserDetail(object).subscribe(
    //   (res) => {
    //   },
    //   (err) => {}
    // );

    if (this.otp == this.smsOTP) {
      // this.attemptRegister();
      this.LoginAsOTP(this.data.UserId);
    } else {
      this.invalidOTP = true;
    }
  }
  async presentAlert(msg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Alert",
      message: msg,
      buttons: ["OK"],
    });

    await alert.present();
  }

  async LoginAsOTP(UserId) {
    this.dialogRef.close();

    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Login in...",
    });
    await loading.present();


    this.loginService.loginWithOTP(UserId).subscribe({
      next: async (res) => {
        this.userDetails = res;
    
        let object: any = {
          DeviceId: (await Device.getId()).identifier,
          UserId: parseInt(this.userDetails.UserId),
        };
        this.SaveSession(object);
        localStorage.setItem("agentuserid", this.userDetails.UserId);
        localStorage.setItem("token", this.userDetails.AccessToken);
        localStorage.setItem("userType", this.userDetails.UserTypeId);
        localStorage.setItem("name", this.userDetails.FName);
        localStorage.setItem("mail", this.userDetails.Email);
        localStorage.setItem("number", this.userDetails.Mobile1);
        localStorage.setItem("ProfilePic", this.userDetails.ProfilePic);

        localStorage.setItem("isExpired", "false");
        
        this.adminService.isAuthenticated.next(true);
        if (this.userDetails.UserTypeId == 1) {
          const toast = await this.toastController.create({
            message: "Login Successfully",
            position: "top",
            duration: 2000,
            color: "success",
          });
          toast.present();

          localStorage.setItem("lg_d_i", this.encryptionService.encryptUsingAES256("true"))
          this.router.navigate(["builder-home"], { replaceUrl: true });
        }
        if (this.userDetails.UserTypeId == 2) {
          const toast = await this.toastController.create({
            message: "Login Successfully",
            position: "top",
            duration: 2000,
            color: "success",
          });
          toast.present();
          localStorage.setItem("lg_d_i", this.encryptionService.encryptUsingAES256("true"))
          this.router.navigate(["agent-home"], { replaceUrl: true });
        }
        this.sideBarEventService.toggleIsLoaded(true);
        await loading.dismiss();
      },
      error: async (error) => {
        const toast = await this.toastController.create({
          message: "Login fail try again",
          position: "top",
          duration: 2000,
          color: "danger",
        });
        toast.present();
        await loading.dismiss();
      }
    });
  }
  SaveSession(object) {
    this.loginService.SaveSession(object).subscribe((res: any) => {});
  }
}
